import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Card, Row, Col, FormText } from 'reactstrap';
import styles from 'components/styles.module.scss';
import TRMSGS from 'constants/Translations/Localization';
import { BEHAVIOUR } from 'helpers/constants';
import { getLocalizedText } from 'helpers/language';

const FreeTextComponent = (props) => {
  const { data, isResponseWrong, index, errors, language } = props;
  const answer = data.answer;

  const handleKeyUp = e => {
    e.currentTarget.value = e.currentTarget.value.trimLeft();
  };

  return (
    <Card
      className={
        isResponseWrong
          ? `${styles["highlight-div"]} ${styles["card-ui"]} m-3 p-3`
          : `${styles["card-ui"]} m-3 p-3`
      }
    >
      <Row>
        <Col md={11} className={`${styles["custom-col"]} ps-1`}>
          <span>
            <span>
              {data.behaviour === BEHAVIOUR.MANDATORY ? "*" : null}
            </span>
            {index + 1}.
          </span>
          <div
            className={
              data.behaviour === BEHAVIOUR.MANDATORY
                ? `${styles["questions-ui"]} pe-0 ps-2`
                : "ps-2"
            }
            dangerouslySetInnerHTML={{
              __html: getLocalizedText(language, data.question, data.sp_question),
            }}
          ></div>
        </Col>
      </Row>
      <div className="mt-2">
        <FormGroup>
          <Input
            type="textarea"
            id={`${index}`}
            name={`${index}`}
            onBlur={(val) => {
              data.setSelectedOption({
                ...(answer?.[0] || {}),
                value: val.target.value,
              });
            }}
            placeholder={TRMSGS.writeHere}
            onKeyUp={handleKeyUp}
          />
        </FormGroup>
        <div>
          <FormText className={styles["error-text"]} color="danger">
            {errors}
          </FormText>
        </div>
      </div>
    </Card>
  );
};

FreeTextComponent.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isResponseWrong: PropTypes.bool,
  errors: PropTypes.string,
  language: PropTypes.string,
};

export default FreeTextComponent;
